import { EventSlot } from './EventSlot';

export class EventSlotList {
  public date: Date;

  public slots: EventSlot[] = [];
}